import React, { useEffect, useState } from "react";
import { Stack, Box, Typography, Tabs, Tab } from "@mui/material";
import Chart from "react-apexcharts";
import {
  GET_CUSTOMER_BILLING_TYPE_GRAPH,
  GET_PROJECT_BILLING_TYPE_GRAPH,
  GET_BROKER_BILLING_TYPE_GRAPH,
  GET_PROJECT_LAG_GRAPH,
  GET_BROKER_LAG_GRAPH,
} from "../../constants/ApiRoute";
import { authHeader } from "../comman/MainFunction";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import API from "../comman/API";
import { PolarArea } from "react-chartjs-2";
import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import NoRecordFound from "../comman/NoRecordFound";

// Register the required components
ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

export default function BillingTypeAvgLagGraph(props) {
  const { headerTab, customerTab, brokerTab, selectedCustomer } = props;

  const [value, setValue] = useState(0);
  const [ploarGraphData, setPloarGraphData] = useState([]);
  const [ploarGraphOptionData, setPloarGraphOptionData] = useState([]);
  const [ploarGraphBrokerData, setPloarGraphBrokerData] = useState([]);
  const [ploarGraphOptionBrokerData, setPloarGraphOptionBrokerData] = useState(
    []
  );
  console.log(ploarGraphData,'ploarGraphDataploarGraphData')
  const [seriessBT, setBTSeries] = useState([]);
  const [labelssBT, setBTLabels] = useState([]);

  useEffect(() => {
    if (customerTab.customerId && customerTab.projectId == "") {
      getBillingTypeFunc(customerTab.customerId, "customer");
    }
    if (customerTab.projectId) {
      getBillingTypeFunc(customerTab.projectId, "project");
    }
    if (customerTab.brokerId) {
      getBillingTypeFunc(customerTab.brokerId, "broker");
    }
  }, [customerTab]);

  useEffect(() => {
    getProjectLag();
  }, [customerTab.projectId]);

  useEffect(() => {
    getBrokerLag();
  }, [customerTab.brokerId]);

  const getBillingTypeFunc = async (idValue, typeFunc) => {
    let data = {};
    let urlPath = "";

    if (typeFunc == "customer") {
      data.customerId = idValue ? idValue : "";
      urlPath = GET_CUSTOMER_BILLING_TYPE_GRAPH;
    } else if (typeFunc == "project") {
      data.projectId = idValue ? idValue : "";
      urlPath = GET_PROJECT_BILLING_TYPE_GRAPH;
    } else if (typeFunc == "broker") {
      data.userId = idValue ? idValue : "";
      urlPath = GET_BROKER_BILLING_TYPE_GRAPH;
    }

    const config = {
      method: "GET",
      url: urlPath,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        const seriesData = data
          .filter((item) => item.billingType != null)
          .map((item) => item.billingTypeCount);

        const labelsData = data
          .filter((item) => item.billingType != null)
          .map((item) => item.billingType);

        setBTSeries(seriesData);
        setBTLabels(labelsData);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);

        if (v.message == "No record found.") {
          setBTSeries([]);
          setBTLabels([]);
        }

        console.log("datadata", data);
      }
    } finally {
    }
  };

  const getProjectLag = async () => {
    let data = {
      projectId: customerTab.projectId,
    };

    const config = {
      method: "GET",
      url: GET_PROJECT_LAG_GRAPH,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        const dataVal = {
          labels: data.map((entry) => entry.UserName),
          datasets: [
            {
              // label: "Average Lag Time",
              label: "",
              data: data.map((entry) => entry.AvgLaqTime),
              backgroundColor: [
                "rgba(255, 99, 132, 0.2)",
                "rgba(75, 192, 192, 0.2)",
              ],
              borderColor: ["rgb(255, 99, 132)", "rgb(75, 192, 192)"],
              borderWidth: 1,
            },
          ],
        };

        const options = {
          responsive: true,
          scales: {
            r: {
              angleLines: {
                display: false,
              },
              suggestedMin: 0,
              suggestedMax: 40, // Adjust max based on your data range
            },
          },
          plugins: {
            legend: {
              display: false, // Hide the legend if that's the "top label" you're referring to
            },
            tooltip: {
              callbacks: {
                label: function (context) {
                  const value = context.raw; // Access the raw data value
                  return `${value.toFixed(2)}`; // Format with 2 decimal places
                },
              },
            },
          },
        };

        setPloarGraphOptionData(options);
        setPloarGraphData(dataVal);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
      }
    } finally {
    }
  };

  const getBrokerLag = async () => {
    // Test Data Start

    // const dataValTest = {
    //   labels: ["broker 1", "broker 2"],
    //   datasets: [
    //     {
    //       label: "Average Lag Time",
    //       data: [10,20],
    //       backgroundColor: [
    //         "rgba(255, 99, 132, 0.2)",
    //         "rgba(75, 192, 192, 0.2)"
    //       ],
    //       borderColor: [
    //         "rgb(255, 99, 132)",
    //         "rgb(75, 192, 192)"
    //       ],
    //       borderWidth: 1,
    //     },
    //   ],
    // };

    // const optionsTest = {
    //   responsive: true,
    //   scales: {
    //     r: {
    //       angleLines: {
    //         display: false,
    //       },
    //       suggestedMin: 0,
    //       suggestedMax: 40,
    //     },
    //   },
    // };
    // setPloarGraphOptionBrokerData(optionsTest)
    // setPloarGraphBrokerData(dataValTest)

    // Test Data End

    let data = {
      userId: customerTab.brokerId,
    };

    const config = {
      method: "GET",
      url: GET_BROKER_LAG_GRAPH,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        const dataVal = {
          labels: data.map((entry) => entry.Name),
          datasets: [
            {
              // label: "Average Lag Time",
              label: "",
              data: data.map((entry) => entry.AvgLaqTime),
              backgroundColor: [
                "rgba(255, 99, 132, 0.2)",
                "rgba(75, 192, 192, 0.2)",
              ],
              borderColor: ["rgb(255, 99, 132)", "rgb(75, 192, 192)"],
              borderWidth: 1,
            },
          ],
        };

        const options = {
          responsive: true,
          scales: {
            r: {
              angleLines: {
                display: false,
              },
              suggestedMin: 0,
              suggestedMax: data.length, // Adjust max based on your data range
            },
          },
          plugins: {
            legend: {
              display: false, // Hide the legend if that's the "top label" you're referring to
            },
            tooltip: {
              callbacks: {
                label: function (context) {
                  const value = context.raw; // Access the raw data value
                  return `${value.toFixed(2)}`; // Format with 2 decimal places
                },
              },
            },
          },
        };

        setPloarGraphOptionBrokerData(options);
        setPloarGraphBrokerData(dataVal);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
      }
    } finally {
    }
  };

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  const CustomTabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {Object.values(customerTab) && (
        <Box className="dashboard-countbox">
          <Box
            className="dashboard-tabs"
            sx={{ borderBottom: 1, borderColor: "divider" }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              {customerTab.customerId ? (
                <Tab label="Billing Type" {...a11yProps(0)} />
              ) : (
                ""
              )}

              {customerTab.projectId ? (
                <Tab label="Average Lag" {...a11yProps(1)} />
              ) : (
                ""
              )}
            </Tabs>
          </Box>

          {customerTab.customerId ? (
            <CustomTabPanel
              className="dashboard-tab-content"
              value={value}
              index={0}
            >
              {labelssBT && labelssBT.length > 0 ? (
                <div
                  className="donut bill-avg-graph"
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                    margin: "0 auto",
                    height: "265px",
                  }}
                >
                  <Chart
                    options={{
                      labels: labelssBT,
                      plotOptions: {
                        pie: {
                          donut: {
                            size: "60%",
                          },
                        },
                        legend: {
                          display: false, // This hides the legend
                        },
                      },
                    }}
                    series={seriessBT}
                    type="donut"
                    width="100%"
                    height="200px"
                  />
                </div>
              ) : (
                // <Typography sx={{ textAlign: "center", margin: "3rem" }}>
                //   No Record Found
                // </Typography>
                <NoRecordFound />
              )}
            </CustomTabPanel>
          ) : (
            ""
          )}

          {customerTab.brokerId || customerTab.projectId ? (
            <CustomTabPanel
              className="dashboard-tab-content"
              value={value}
              index={1}
            >
              {
                // Check if both brokerId and projectId are truthy
                customerTab.brokerId && customerTab.projectId ? (
                  // Render PolarArea component if ploarGraphOptionBrokerData is defined and responsive is true
                  ploarGraphOptionBrokerData &&
                  ploarGraphOptionBrokerData.responsive ? (
                    <div className="chart-container">
                      <PolarArea
                        data={ploarGraphBrokerData}
                        options={ploarGraphOptionBrokerData}
                      />
                    </div>
                  ) : (
                    // Render "No Record Found" message if conditions for rendering PolarArea are not met
                    // <Typography sx={{ textAlign: "center", margin: "3rem" }}>
                    //   No Record Found
                    // </Typography>
                    <NoRecordFound />
                  )
                ) : // Render PolarArea component if ploarGraphOptionData is defined and responsive is true
                ploarGraphOptionData && ploarGraphOptionData.responsive ? (
                  <div className="chart-container">
                    <PolarArea
                      data={ploarGraphData}
                      options={ploarGraphOptionData}
                    />
                  </div>
                ) : (
                  // Render "No Record Found" message if conditions for rendering PolarArea are not met
                  // <Typography sx={{ textAlign: "center", margin: "3rem" }}>
                  //   No Record Found
                  // </Typography>
                  <NoRecordFound />
                )
              }
            </CustomTabPanel>
          ) : (
            ""
          )}
        </Box>
      )}
    </>
  );
}
